import React, { useState, useEffect } from 'react';

// Componente Hero para OncoFHIR Prescribe
const MESSAGES = [
  "Acompañamiento clínico especializado para centros de oncología.",
  "Validación automática de dosis y alertas de seguridad en quimioterapia.",
  "Trazabilidad completa: Prescripción, Farmacia y Enfermería.",
  "Software de quimioterapia diseñado por oncólogos para oncólogos.",
  "Reducción de errores prevenibles en el flujo de medicación oncológica."
];

const Hero: React.FC = () => {
  const [currentMsgIndex, setCurrentMsgIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentMsgIndex((prev) => (prev + 1) % MESSAGES.length);
        setIsFading(false);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 bg-medical-gradient overflow-hidden min-h-screen flex flex-col items-center">
      
      <div className="absolute top-0 right-0 w-[60%] h-full bg-[#0061A0]/[0.03] -skew-x-12 translate-x-1/4 -z-0"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-24">
          <div className="lg:w-1/2 text-center lg:text-left">
            <div className="mb-8 flex justify-center lg:justify-start">
              <img 
                src="https://raw.githubusercontent.com/jcalcedo/webpageimages/refs/heads/main/logoOncoFHIROficial.png" 
                alt="OncoFHIR Prescribe - Software de Quimioterapia" 
                className="h-20 md:h-24 w-auto object-contain transition-transform hover:scale-105"
                loading="eager"
              />
            </div>

            <div className="inline-flex items-center gap-2 bg-fhir/10 text-fhir text-[10px] font-black tracking-widest uppercase px-4 py-2 rounded-lg mb-8 border border-fhir/20">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-fhir opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-fhir"></span>
              </span>
              PROGRAMA EARLY ADOPTER: 2026
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-[900] text-medical leading-[1.1] mb-6 tracking-tighter italic">
              Software de Prescripción y <br/>
              <span className="text-dark not-italic">Administración de Quimioterapia</span>
            </h1>
            
            <p className="text-lg text-gray-500 mb-10 leading-relaxed max-w-xl font-medium">
              Implementación inmediata para clínicas oncológicas. Los participantes del programa reciben <strong className="text-fhir">2 meses sin costo</strong> y soporte prioritario nativo en español.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center lg:justify-start items-center">
              <button 
                onClick={scrollToContact}
                className="bg-fhir hover:bg-orange-600 text-white px-10 py-5 rounded-2xl text-lg font-black transition-all transform hover:scale-105 shadow-2xl shadow-fhir/40 uppercase tracking-widest"
              >
                SOLICITAR ACCESO
              </button>
              <div className="text-left hidden sm:block border-l-2 border-gray-100 pl-6">
                <p className="text-[10px] text-gray-400 font-black uppercase tracking-widest mb-1">Onboarding Ágil</p>
                <p className="text-sm font-bold text-dark italic">Despliegue en tiempo récord</p>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2 relative w-full">
            <div className="relative mx-auto lg:ml-auto max-w-2xl">
              <div className="relative bg-white p-3 rounded-[3rem] shadow-[0_40px_100px_-20px_rgba(0,0,0,0.15)] border border-gray-100 overflow-hidden">
                <img 
                  src="https://raw.githubusercontent.com/jcalcedo/webpageimages/main/chemonurse2.png" 
                  alt="Enfermera administrando quimioterapia con software OncoFHIR" 
                  className="w-full h-[400px] lg:h-[600px] object-cover rounded-[2.5rem]"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = 'https://images.unsplash.com/photo-1576091160550-2173bdb999ef?auto=format&fit=crop&q=80&w=1000';
                  }}
                />
                
                <div className="absolute bottom-10 left-10 right-10 bg-white/95 backdrop-blur-md p-6 rounded-2xl shadow-2xl border border-white/50 hidden md:block text-left min-h-[120px] flex flex-col justify-center">
                  <p className="text-[10px] text-gray-400 font-black uppercase tracking-widest mb-2">OncoFHIR Prescribe</p>
                  <p className={`text-sm font-black text-medical italic leading-tight transition-all duration-500 ${isFading ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'}`}>
                    {MESSAGES[currentMsgIndex]}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
